"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Footer_container_1 = __importDefault(require("./Footer.container"));
exports.default = Footer_container_1.default;
//# sourceMappingURL=index.js.map